<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Centro de Costo</th>
                            <th>Descripción</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="cc in costCenterUsers" :key="cc.name">
                            <td>{{ cc.name }}</td>
                            <td>{{ cc.description }}</td>
                        </tr>
                    </tbody>
                </table>
            </div> 
        </div>    
    </div>
</template>
<script>
export default {
    props: ["costCenterUsers"],
    methods: {
    }
};
</script>
